import { Pipe, PipeTransform } from '@angular/core';

import { toApiDate } from '../utils/date-utils';

/**
 * Formats a calendar date as `YYYY-MM-DD` for the API payload.
 *
 * The output format is unchanged - this is what every backend call already expects. What
 * changed is how the input is read: it now goes through `toApiDate`, which builds and
 * reads dates from local year/month/day components only.
 *
 * The old implementation did `new Date(value)` and then read local getters. For a
 * 'YYYY-MM-DD' string that parses as UTC midnight, so in Canada and the USA it returned
 * the previous day - and because this pipe emits 'YYYY-MM-DD' and several submit paths
 * run a value through it more than once, each extra pass shifted another day.
 * `toApiDate` is idempotent, so repeated conversions are now harmless.
 */
@Pipe({
  name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): string {
    const formatted = toApiDate(value);
    if (formatted) {
      return formatted;
    }
    // A Date that cannot be formatted is a typo the datepicker accepted (its parser reads
    // '12-12-024' as year 24). Returning it unchanged would put a raw Date in the payload,
    // which JSON.stringify turns into a UTC instant like '0024-12-11T18:06:32.000Z' - the
    // wrong type and the wrong day. Send nothing instead.
    if (value instanceof Date) {
      return '';
    }
    // Non-date input is passed through untouched, matching the previous behaviour so that
    // callers which run other values through this pipe keep working.
    return value;
  }

}
